import { Routes } from "~/routes";
import { API_QUERY_BASE_URLS, ApiQueryEndpoints } from "../../types";

// // // //

/**
 * API_EXPLORER_ROUTES
 * Maps an ApiQueryEndpoints value to its corresponding API Explorer page.
 * NOTE - endpoints without an API Explorer page are intentionally omitted
 */
export const API_EXPLORER_ROUTES: Partial<Record<ApiQueryEndpoints, Routes>> = {
    [ApiQueryEndpoints.AssetV4]: Routes.apiToolsV4Assets,
    [ApiQueryEndpoints.TokenV4]: Routes.apiToolsV4Tokens,
    [ApiQueryEndpoints.NetworkV4]: Routes.apiToolsV4Networks,
    [ApiQueryEndpoints.PlatformV4]: Routes.apiToolsV4Platforms,
    [ApiQueryEndpoints.IssuerV4]: Routes.apiToolsV4Issuers,
    [ApiQueryEndpoints.ManagerV4]: Routes.apiToolsV4Managers,
    [ApiQueryEndpoints.TransactionsV4]: Routes.apiToolsV4Transactions,
    [ApiQueryEndpoints.ServiceProviderV4]: Routes.apiToolsV4ServiceProviders,
    [ApiQueryEndpoints.AssetClassV4]: Routes.apiToolsV4AssetClasses,
    [ApiQueryEndpoints.AssetAggregatesV4]: Routes.apiToolsV4AssetAggregates,
    [ApiQueryEndpoints.AssetTimeseriesV4]: Routes.apiToolsV4AssetTimeseries,
    [ApiQueryEndpoints.TokenAggregatesV4]: Routes.apiToolsV4TokenAggregates,
    [ApiQueryEndpoints.TokenTimeseriesV4]: Routes.apiToolsV4TokenTimeseries,
    [ApiQueryEndpoints.FundFlowsV4]: Routes.apiToolsV4FundFlows,
    [ApiQueryEndpoints.FundFlowsTimeseriesV4]:
        Routes.apiToolsV4FundFlowsTimeseries,
    [ApiQueryEndpoints.NetFlowsV4]: Routes.apiToolsV4NetFlows,
    [ApiQueryEndpoints.NetFlowsTimeseriesV4]:
        Routes.apiToolsV4NetFlowsTimeseries,
    [ApiQueryEndpoints.TokenHoldersV4]: Routes.apiToolsV4TokenHolders,
    [ApiQueryEndpoints.MeasureV4]: Routes.apiToolsV4Measures,
};

/**
 * BASE_URL_TO_API_EXPLORER_ROUTE
 * Maps an API base URL (ie "/v4/assets") to its API Explorer page.
 * NOTE - the ApiDocs component receives the base URL rather than the
 * ApiQueryEndpoints value, so we invert API_QUERY_BASE_URLS here
 */
const BASE_URL_TO_API_EXPLORER_ROUTE: Record<string, Routes> =
    Object.fromEntries(
        Object.entries(API_EXPLORER_ROUTES).map(([endpoint, route]) => [
            API_QUERY_BASE_URLS[endpoint as ApiQueryEndpoints],
            route,
        ]),
    );

/**
 * getApiExplorerRoute
 * Returns the API Explorer page for the given API base URL, when one exists
 * @param baseUrl - the API base URL passed into the ApiDocs component (ie "/v4/assets")
 */
export function getApiExplorerRoute(baseUrl: string): Routes | undefined {
    return BASE_URL_TO_API_EXPLORER_ROUTE[baseUrl];
}
